import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Stack } from '@mantine/core';
import type { IObservableArray } from 'mobx';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { Campaign, Targeting } from '@feathr/blackbox';
import { CardV2 as Card, Checkbox, Input, SegmentedControl } from '@feathr/components';

import * as styles from './Interests.css';

interface IProps {
  campaign: Campaign;
  targetings: IObservableArray<Targeting>;
}

function Interests({}: Readonly<IProps>): JSX.Element {
  const [search, setSearch] = useState<string>('');
  const { t } = useTranslation();

  function handleSearch(value?: string): void {
    setSearch(value || '');
  }

  // TODO: pull actual interests from the backend
  return (
    <Card width={'full'}>
      <Card.Header title={t('Interests')} />
      <Card.Content addVerticalGap={true}>
        <Input
          isClearable={true}
          onChange={handleSearch}
          placeholder={t('Search by keyword, interest or audience name')}
          prefix={<FontAwesomeIcon icon={faSearch} />}
          type={'text'}
          value={search}
        />
        <Group justify={'space-between'}>
          <h4 className={styles.title}>{t('Recommended')}</h4>
          <SegmentedControl
            data={[
              { label: t('Most Popular'), value: 'most_popular' },
              { label: t('Philanthropy'), value: 'philanthropy' },
              { label: t('Social Causes'), value: 'social_causes' },
              { label: t('Income'), value: 'income' },
            ]}
          />
        </Group>
        <Checkbox
          label={
            <Stack gap={0}>
              Climate Action Supporters
              <span className={styles.description}>Environment</span>
            </Stack>
          }
          layout={'well'}
          name={'interests'}
          value={true}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              Healthcare Advocates
              <span className={styles.description}>Healthcare</span>
            </Stack>
          }
          layout={'well'}
          name={'interests'}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              Education Champions
              <span className={styles.description}>Education</span>
            </Stack>
          }
          layout={'well'}
          name={'interests'}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              Social Justice Warriors
              <span className={styles.description}>Social</span>
            </Stack>
          }
          layout={'well'}
          name={'interests'}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              Arts & Culture Lovers
              <span className={styles.description}>Arts</span>
            </Stack>
          }
          layout={'well'}
          name={'interests'}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              Mental Health Advocates
              <span className={styles.description}>Health</span>
            </Stack>
          }
          layout={'well'}
          name={'interests'}
        />
      </Card.Content>
    </Card>
  );
}

export default observer(Interests);
